import React from 'react';
class Play_Video extends React.Component{
    render(){
        return(<div>
            <div style={{padding:"56.25% 0 0 0",position:"relative"}}><iframe src="https://player.vimeo.com/video/585422236?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style={{position:"absolute",top:"0",left:"0",width:"100%",height:"100%"}} title="21 Lifeboat Release Mechanism PREVIEW MIX.mp4"></iframe></div>
        </div>)
    }

}
export default Play_Video